import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiHelperFunction from "../../api";

interface APIResponse {
  status: number;
  message: string;
  data?: any;
}
interface TaxFilingState {
  status: "idle" | "loading" | "succeeded" | "failed";
  loading: "idle" | "loading" | "succeeded" | "failed";
  userData: any;
  taxfillingOrderList: any;
  taxFilingData: any;
  taxFilingDataReview: any;
  reviewstatus: "idle" | "loading" | "succeeded" | "failed";
  formattedData: any;
  error: string;
  total_records?: number;
  records_limit?: number;
  data: any[];
}
const initialState: TaxFilingState = {
  status: "idle",
  loading: "idle",
  userData: null,
  taxfillingOrderList: null,
  taxFilingData: null,
  taxFilingDataReview: null,
  reviewstatus: "idle",
  formattedData: null,
  error: "",
  data: [],
  total_records: 0,
  records_limit: 10,
};
export const createTaxFiling = createAsyncThunk(
  "tax-filing/create-tax-filing",
  async (payload: any, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");

    try {
      const response = await ApiHelperFunction({
        url: "/tax-filing/create-tax-filing",
        method: "post",
        data: payload,
        dispatch,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `${token}` : "",
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

export const getTaxFilingData = createAsyncThunk(
  "tax-filing/get-tax-filing-list/",
  async (payload: any, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");
    try {
      const response = await ApiHelperFunction({
        url: `tax-filing/get-tax-filing-list?offset=${payload.offset}&limit=${payload.limit}`,
        method: "get",
        dispatch,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `${token}` : "",
        },
      });

      return response?.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);
export const getTaxFilingDataById = createAsyncThunk(
  "tax-filing/get-tax-filing-files-with-documents",
  async (payload: any, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");
    try {
      const response = await ApiHelperFunction({
        url: `tax-filing/get-tax-filing-files-with-documents?tax_filing_file_id=${payload.tax_filing_file_id}`,
        method: "get",
        dispatch,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `${token}` : "",
        },
      });

      return { data: response?.data?.data, code: response?.data };
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

export const uploadTaxFilingForm = createAsyncThunk(
  "tax-filing/upload-tax-filing-file",
  async (payload: FormData, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");
    try {
      const response = await ApiHelperFunction({
        url: "/tax-filing/upload-tax-filing-file",
        method: "post",
        data: payload,
        dispatch,
        headers: {
          
          Authorization: token ? `${token}` : "",
        },
      });
      return response.data;
    } catch (error: any) {
      console.log(error.data?.message, "error in tax filing upload");
  return rejectWithValue(
    error
  );
}
  },
);
export const deleteUploadedDocument = createAsyncThunk(
  "tax-filing/delete-uploaded-documents",
  async (id: number, { dispatch }) => {
    const token = localStorage.getItem("user_token");

    const response = await ApiHelperFunction({
      url: `tax-filing/delete-uploaded-documents?tax_filing_document_id=${id}`,
      method: "delete",
      dispatch,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `${token}` : "",
      },
    });

    return response?.data;
  },
);

export const taxFilingSlice = createSlice({
  name: "tax-filing",
  initialState,
  reducers: {
    resetAll: (state) => {
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTaxFiling.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createTaxFiling.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.userData = action.payload?.data;
      })
      .addCase(createTaxFiling.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(getTaxFilingData.pending, (state) => {
        state.loading = "loading";
        state.taxFilingDataReview = null;
        
      })
      .addCase(getTaxFilingData.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.taxfillingOrderList = action.payload;
        state.total_records = action.payload.total_records;
        // console.log(state.total_records,"state.total_records")
        // console.log(state.taxfillingOrderList,"state.tax");
      })
      .addCase(getTaxFilingData.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.payload as string;
      })
      .addCase(uploadTaxFilingForm.pending, (state) => {
        state.status = "loading";
      })
      .addCase(uploadTaxFilingForm.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.taxFilingData = action.payload;
      })
      .addCase(uploadTaxFilingForm.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(getTaxFilingDataById.pending, (state) => {
        state.reviewstatus = "loading";
      })
      .addCase(getTaxFilingDataById.fulfilled, (state, action) => {
        state.reviewstatus = "succeeded";
        state.taxFilingDataReview = action.payload?.data;
      })
      .addCase(getTaxFilingDataById.rejected, (state, action) => {
        state.reviewstatus = "failed";
        state.error = action.payload as string;
      });
  },
});
export const { resetAll } = taxFilingSlice.actions;
export default taxFilingSlice.reducer;
